import { UseQueryResult, useQuery } from 'react-query';
import { AxiosError } from 'axios';
import { showErrorSnackbar } from 'components/shared/Snackbar';
import {
  EmployeeMessage,
  TaskDefinitionGroup,
  TaskDefinitionStatus
} from '../types';
import { getEmployeeMessages } from 'RestAPIs/employees/messages';
import { getContentRange } from '../utilts';

type EmployeeMessageResponse = [EmployeeMessage[], [number, number, number]];

const useGetEmployeeMessages = (
  taskId: string,
  status: TaskDefinitionStatus,
  taskDefinitionGroup?: TaskDefinitionGroup,
  range?: string,
  isEmployeeCard?: boolean
): UseQueryResult<EmployeeMessageResponse> => {
  return useQuery({
    queryKey: ['employeeMessages', taskId, status, taskDefinitionGroup, range],
    queryFn: async () => {
      const response = await getEmployeeMessages(
        taskId,
        status,
        taskDefinitionGroup,
        range,
        isEmployeeCard
      );
      const responseRange = getContentRange(response.headers['content-range']);

      return [response.data, responseRange];
    },
    onError: (error: AxiosError) => {
      showErrorSnackbar(error.message);
    }
  });
};

export default useGetEmployeeMessages;
